import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import CurrencyResponse, { CurrencyConversion } from "../interfaces/ip-currency-response";
import IpErrorResponse from "../interfaces/ip-error-response";
import { IpAuthService } from "./ip-auth.service";
import { IpCountryService } from "./ip-country.service";
import { IpProfileService } from "./ip-profile.service";
import { IpSnackbarService } from "./ip-snackbar.service";

@Injectable({
  providedIn: 'root',
})
export class IpCurrencyService {
  api = environment.api;
  private currenciesSubject: BehaviorSubject<CurrencyResponse[] | null> =
    new BehaviorSubject<CurrencyResponse[] | null>(null);
  public currencies$: Observable<CurrencyResponse[] | null> =
    this.currenciesSubject.asObservable();
  private currencySubject: BehaviorSubject<CurrencyResponse | null> =
    new BehaviorSubject<CurrencyResponse | null>(null);
  public currency$: Observable<CurrencyResponse | null> =
    this.currencySubject.asObservable();

  constructor(
    private http: HttpClient,
    private ipAuthService: IpAuthService,
    private ipSnackbarService: IpSnackbarService,
    private ipCountryService: IpCountryService,
    private ipProfileService: IpProfileService,
  ) {
    this.ipAuthService.currentSession$.subscribe(session => {
      if (session) {
        this.setCurrencies();
      }
      else {
        this.currencySubject.next(null);
      }
    });
  }

  private getCurrencies(): Observable<CurrencyResponse[]> {
    return this.http.get<CurrencyResponse[]>(
      `${this.api}/invopay/currencies`
    );
  }

  // TODO: use rxjs operators (and improve)
  setCurrencies() {
    this.getCurrencies().subscribe({
      next: currencies => {
        this.currenciesSubject.next(currencies);
        this.ipProfileService.enterprise$.subscribe({
          next: enterpriseProfile => {
            if (enterpriseProfile) {
              const foundCurrency = currencies.find(
                currency => currency.id === enterpriseProfile.currencyId
              );
              if (!foundCurrency) {
                this.currencySubject.error('No se pudo obtener la moneda.');
                return;
              }
              this.currencySubject.next(foundCurrency);
            }
          },
          error: (e: IpErrorResponse) => {
            this.ipSnackbarService.showErrorMessage(e);
          },
        });
      },
      error: (e: IpErrorResponse) => {
        this.ipSnackbarService.showErrorMessage(e);
      },
    });
  }

  setCurrency(currency: CurrencyResponse) {
    this.currencySubject.next(currency);
  }

  getActiveCurrencyConversion(
    fromCurrencyCode: number,
    toCurrencyCode: number
  ): Observable<CurrencyConversion> {
    return this.http.get<CurrencyConversion>(
      `${this.api}/invopay/currency-conversions/active/${fromCurrencyCode}/${toCurrencyCode}/last`
    );
  }
}
